import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL;

// Logs one visit per route change (except the admin panel) so the admin
// analytics dashboard can show traffic volume and source (Google, Ads,
// ChatGPT, Gemini, Perplexity, direct, ...).
export function useTracking() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    try {
      fetch(`${API}/api/track`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          path: pathname,
          referrer: document.referrer || "",
          query: window.location.search || "",
        }),
        keepalive: true,
      }).catch(() => {});
    } catch (e) { /* ignore */ }
  }, [pathname]);
}
